import { LOGO_URL } from '@/lib/logo'

interface LogoWordmarkProps {
  size?: number
  className?: string
  style?: React.CSSProperties
}

/**
 * Wordmark "SELAH" qui s'adapte au thème (dark/light) via CSS mask-image.
 * Utiliser <img src={LOGO_URL}> uniquement sur fond fixe (ex: LandingPage crème).
 */
// SVG viewBox "80 370 900 250" → ratio 900:250 = 3.6
const LOGO_ASPECT = 900 / 250

export default function LogoWordmark({ size = 120, className, style }: LogoWordmarkProps) {
  const height = Math.round(size / LOGO_ASPECT)
  return (
    <div
      role="img"
      aria-label="Selah"
      className={className}
      style={{
        width: size,
        height,
        backgroundColor: 'var(--selah-text)',
        maskImage: `url(${LOGO_URL})`,
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        WebkitMaskImage: `url(${LOGO_URL})`,
        WebkitMaskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        flexShrink: 0,
        ...style,
      }}
    />
  )
}
